import Router from 'vue-router'

export default new Router({
  mode: 'history',
  base: import.meta.env.BASE_URL,
  strict: true,
  routes: [
    {
      path: '/',
      alias: '/buddies',
      name: 'users',
      component: () => import('@/views/users.vue')
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('@/views/contacts.vue')
    },
    {
      path: '/queues',
      name: 'queues',
      component: () => import('@/views/queues.vue'),
      redirect: '/queues/dashboard',
      children: [
        {
          path: 'dashboard',
          component: () => import('@/components/queues/index.vue'),
          name: 'queues-dashboard'
        },
        {
          path: 'reports',
          component: () => import('@/components/queues/reports/index.vue'),
          name: 'queues-reports'
        },
        {
          path: 'schedules',
          component: () => import('@/components/queues/schedules/index.vue'),
          name: 'queues-schedules'
        }
      ]
    },
    {
      path: '/queues/dashboard',
      name: 'queues_dashboard'
    },
    {
      path: '/conferences',
      name: 'conferences',
      component: () => import('@/views/conferences.vue')
    },
    {
      path: '/video_conferences',
      name: 'video-conferences',
      component: () => import('@/views/video_conferences.vue')
    },
    {
      path: '/announcements',
      name: 'announcements',
      component: () => import('@/views/announcements.vue')
    },
    {
      path: '/parking/:extension?',
      name: 'parking',
      sensitive: true,
      props: true,
      component: () => import('@/views/parking.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/settings.vue'),
      redirect: '/settings/phone_status',
      children: [
        {
          path: 'phone_status',
          component: () => import('@/components/settings/drawer/pages/index.vue'),
          name: 'settings-phone-status'
        },
        {
          path: 'devices',
          component: () => import('@/components/settings/drawer/pages/devices.vue'),
          name: 'settings-devices'
        },
        {
          path: 'account',
          component: () => import('@/components/settings/drawer/pages/account.vue'),
          name: 'settings-account'
        },
        {
          path: 'softphone',
          component: () => import('@/components/settings/drawer/pages/softphone.vue'),
          name: 'settings-softphone'
        },
        {
          path: 'emergency',
          component: () => import('@/components/settings/drawer/pages/emergency.vue'),
          name: 'settings-emergency'
        },
        {
          path: 'notifications',
          component: () => import('@/components/settings/drawer/pages/notifications.vue'),
          name: 'settings-notifications'
        },
        {
          path: 'click_to_dial',
          component: () => import('@/components/settings/drawer/pages/click_to_dial.vue'),
          name: 'settings-click-to-dial'
        },
        {
          path: 'call_screen_pop',
          component: () => import('@/components/settings/drawer/pages/call_screen_pop.vue'),
          name: 'settings-call-screen-pop'
        },
        {
          path: 'stun_servers',
          component: () => import('@/components/settings/drawer/pages/stun_servers.vue'),
          name: 'settings-stun-servers'
        }
      ]
    },
    {
      path: '/settings/phone_status',
      name: 'settings_phone_status'

    },
    {
      path: '/cdrs',
      name: 'cdrs',
      component: () => import('@/views/cdrs.vue')
    },
    {
      path: '/clusterpbx_callback',
      name: 'oauth2',
      component: () => import('@/views/oauth2.vue')
    },
    {
      path: '/embedded_login',
      name: 'embedded_login',
      component: () => import('@/views/embedded_login.vue')
    },
    {
      path: '/chat/:roomType?/:roomId?/:extraPath?',
      name: 'chats',
      sensitive: true,
      props: true,
      component: () => import('@/views/chat.vue')
    },
    {
      path: '/voicemails/:folder?/:id?',
      name: 'voicemails',
      sensitive: true,
      props: true,
      component: () => import('@/views/voicemails.vue')
    },
    {
      path: '/dialer/:phoneNumber?',
      name: 'dialer',
      component: () => import('@/views/dialer.vue')
    },
    {
      path: '/unsupported',
      name: 'unsupported',
      component: () => import('@/views/unsupported.vue')
    },
    {
      path: '/signout',
      name: 'signout',
      component: () => import('@/views/signout.vue')
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/views/access_denied.vue')
    }
  ]
})
